import React from "react";
import { useSwitch } from "../../context/SwitchContext";
import EN from "../../locales/en";
import interpolate from "../../utils/interpolate";
import CheckboxField from "./partials/CheckboxField";
import DisclosureSection from "./partials/DisclosureSection";
import SelectField from "./partials/SelectField";
import TextField from "./partials/TextField";

const YourPaymentDetails = ({
  switchValidationSchema,
  supplierName,
  supplierServiceUserNumber,
}) => {
  const isPaymentDateSelectVisible = Boolean(
    switchValidationSchema?.paymentInfo?.properties?.monthlyPaymentsDate
      ?.required
  );

  const { selectedSwitchTariff } = useSwitch();

  const monthlySpendElec = selectedSwitchTariff?.newSpendMonthlyDDElec ?? 0;
  const monthlySpendGas = selectedSwitchTariff?.newSpendMonthlyDDGas ?? 0;
  const monthlySpendTotal = monthlySpendElec + monthlySpendGas;

  const formatMoney = (amount) => {
    return `£${amount.toFixed(2)}`;
  };

  return (
    <div className="mt-8 border-t border-[#afb6b9]">
      <h2 className="text-[30px] font-bold text-primary mt-6">
        {EN.switch.your_payment_details.title}
      </h2>
      <p className="text-md leading-[1.5] mt-2">
        {EN.switch.your_payment_details.estimated_monthly_dd}{" "}
        {formatMoney(monthlySpendTotal)}
      </p>
      <p className="mt-2">
        {interpolate(EN.switch.your_payment_details.monthly_spend_breakdown, {
          gas: formatMoney(monthlySpendGas),
          elec: formatMoney(monthlySpendElec),
        })}
      </p>
      <p className="mt-2">
        {interpolate(EN.switch.your_payment_details.first_dd_payment, {
          supplierName,
        })}
      </p>
      <h3 className="text-[22px] font-bold mt-6">
        {EN.switch.your_payment_details.account_details}
      </h3>
      <div className="space-y-4">
        <TextField
          key="paymentInfo.bankAccountName"
          name="paymentInfo.bankAccountName"
          label={EN.switch.your_payment_details.account_holder_name}
          placeholder={
            EN.switch.your_payment_details.account_holder_name_placeholder
          }
        />
        <TextField
          key="paymentInfo.bankAccountNumber"
          name="paymentInfo.bankAccountNumber"
          label={EN.switch.your_payment_details.account_number}
          placeholder={
            EN.switch.your_payment_details.account_number_placeholder
          }
        />
        <TextField
          key="paymentInfo.bankSortCode"
          name="paymentInfo.bankSortCode"
          label={EN.switch.your_payment_details.sort_code}
          placeholder={EN.switch.your_payment_details.sort_code_placeholder}
        />
      </div>

      <CheckboxField
        key="paymentInfo.detailsConfirmed"
        name="paymentInfo.detailsConfirmed"
        label={EN.switch.your_payment_details.details_confirmed}
      />
      <CheckboxField
        key="paymentInfo.accountHolderConfirmed"
        name="paymentInfo.accountHolderConfirmed"
        label={EN.switch.your_payment_details.account_holder_confirmed}
      />

      {isPaymentDateSelectVisible && (
        <div className="mt-2">
          <SelectField
            key="paymentInfo.monthlyPaymentsDate"
            name="paymentInfo.monthlyPaymentsDate"
            label={EN.switch.your_payment_details.payment_date_label}
            options={
              switchValidationSchema?.paymentInfo?.properties
                ?.monthlyPaymentsDate?.valid ?? []
            }
            defaultText={EN.switch.your_payment_details.select_day}
          />
        </div>
      )}

      <p className="text-md leading-[1.5] mt-2 font-medium mt-6">
        {EN.switch.your_payment_details.dd_instruction}
      </p>
      <div className="mt-4 border-2 border-primary rounded-[4px] p-4">
        <p>{EN.switch.your_payment_details.to_manager}</p>
        <p className="mt-2">
          {interpolate(EN.switch.your_payment_details.dd_instruction_details, {
            supplierName,
          })}
        </p>
      </div>
      <p className="text-md leading-[1.5] mt-6">
        {interpolate(EN.switch.your_payment_details.debit_amount, {
          amount: formatMoney(monthlySpendTotal),
          supplierName,
          supplierServiceUserNumber: supplierServiceUserNumber ?? "n/a",
        })}
      </p>
      <img
        src="/direct-debit-guarantee.svg"
        className="mt-4 w-32"
        alt={EN.switch.your_payment_details.dd_guarantee_alt}
      />
      <DisclosureSection
        title={EN.switch.your_payment_details.dd_guarantee_title}
        content={
          <>
            <p>{EN.switch.your_payment_details.dd_guarantee_1}</p>
            <p>
              {interpolate(EN.switch.your_payment_details.dd_guarantee_2, {
                supplierName,
              })}
            </p>
            <p>
              {interpolate(EN.switch.your_payment_details.dd_guarantee_3, {
                supplierName,
              })}
            </p>
            <p>
              {interpolate(EN.switch.your_payment_details.dd_guarantee_4, {
                supplierName,
              })}
            </p>
            <p>
              {interpolate(EN.switch.your_payment_details.dd_guarantee_5, {
                supplierName,
              })}
            </p>
          </>
        }
      />
    </div>
  );
};

export default YourPaymentDetails;
